import React, { useState } from "react";
import styles from "./quoteForm.module.css";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

export default function QuoteForm() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    project_description: "",
  });

  const [status, setStatus] = useState("");
  const [errors, setErrors] = useState({
    name: "",
    email: "",
    phone: "",
    project_description: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: name === "phone" ? value.replace(/[^0-9]/g, "") : value,
    });
  };

  const validateForm = () => {
    let formErrors = {};
    let isValid = true;

    if (!formData.name) {
      formErrors.name = "Name is required.";
      isValid = false;
    }

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.email) {
      formErrors.email = "Email is required.";
      isValid = false;
    } else if (!emailPattern.test(formData.email)) {
      formErrors.email = "Please enter a valid email address.";
      isValid = false;
    }

    if (!formData.phone) {
      formErrors.phone = "Phone number is required.";
      isValid = false;
    }

    if (!formData.project_description) {
      formErrors.project_description = "Project description is required.";
      isValid = false;
    }

    setErrors(formErrors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("");

    if (!validateForm()) {
      setStatus("Please fill out the form correctly.");
      return;
    }

    setStatus("Sending...");

    try {
      const response = await fetch("https://admin.ninjascode.com/wp-json/quote-form/v1/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setStatus("Quote request sent successfully! We will contact you soon.");
        setFormData({ name: "", email: "", phone: "", project_description: "" });
      } else {
        setStatus("Failed to send request.");
      }
    } catch {
      setStatus("An error occurred. Please try again.");
    }
  };

  return (
    <section className={styles.quoteFormSec}>
    <form onSubmit={handleSubmit} className={styles.quoteFormContainer}>
      <div className={styles.quoteFormHeading}>
        Thank You for Considering{" "}
        <span className={styles.highlightPurple}> <img
                src="/assets/ninjascode-logo-highlighted.webp"
                alt="Ninjascode"
                width="100%"
                height="100%"
              /></span><br/>
        Step for Your <span className={styles.highlightYellow}>Business Growth</span>
      </div>
      <p className={styles.quoteFormSubtext}>Tell us a little about yourself and your project to help us understand your needs.</p>

      <div className={styles.quoteFormFields}>
        <label className={styles.label}>Name</label>
        <input
          type="text"
          name="name"
          value={formData.name}
          placeholder="Full Name"
          onChange={handleChange}
          className={styles.input}
        />
        {errors.name && <p className={styles.error}>{errors.name}</p>}
      </div>

      <div className={styles.quoteFormFields}>
        <label className={styles.label}>Email</label>
        <input
          type="email"
          name="email"
          value={formData.email}
          placeholder="you@example.com"
          onChange={handleChange}
          className={styles.input}
        />
        {errors.email && <p className={styles.error}>{errors.email}</p>}
      </div>

      <div className={styles.quoteFormFields}>
  <label className={styles.label}>Phone Number</label>
  <PhoneInput
    country={'us'}
    value={formData.phone} 
    onChange={(phone) => setFormData({ ...formData, phone })}
      placeholder="Type Your Contact no"
    inputClass={styles.phoneInputStyled}
    containerClass={styles.phoneContainerStyled}
    inputProps={{
      name: 'phone',
      required: true,
      autoFocus: false,
    }}
    enableSearch
   
  />
  {errors.phone && <p className={styles.error}>{errors.phone}</p>}
</div>


      <div className={styles.quoteFormFields}>
        <label className={styles.label}>Project Details</label>
        <textarea
          name="project_description"
          value={formData.project_description}
          placeholder="Tell us about your idea, needs or any questions you have."
          onChange={handleChange}
          className={styles.textarea}
          rows={4}
        />
        {errors.project_description && <p className={styles.error}>{errors.project_description}</p>}
      </div>

      <button type="submit" className={styles.button}>
        Submit
      </button>

      {status && <p className={styles.statusMessage}>{status}</p>}
    </form>
    </section>
  );
}
